import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { reduce } from 'lodash';
import { PaymentTypes } from '../actions/PaymentActions';
import { ApplicationTypes } from '../actions/ApplicationActions';
import { LoginTypes } from '../actions/LoginActions';

const mapFees = (fees) =>
  reduce(
    fees || [],
    (map, fee) => {
      if (fee.country && fee.country.uuid) map[fee.country.uuid] = fee;
      return map;
    },
    {}
  );
/* ------------- Initial Login State ------------- */
export const INITIAL_STATE = Immutable({
  error: '',
  fetching: false,
  fees: [],
  mappedFees: {},
  quote: null,
  paymentRecord: null,
  paymentMethods: [],
  linkSent: false,
});

/* ------------- Reducers ------------- */
export const onClearCurrent = (state) =>
  state.merge({ quote: null, paymentRecord: null, error: '' });
export const onRequest = (state) => state.merge({ fetching: true });
export const onFeesSuccess = (state, { fees = [] }) =>
  state.merge({
    fetching: false,
    fees,
    mappedFees: mapFees(fees),
  });
export const onSuccess = (state) => state.merge({ fetching: false });
export const onFailure = (state, { error }) =>
  state.merge({ fetching: false, error });
export const onQuoteSuccess = (state, { quote }) =>
  state.merge({ fetching: false, quote, error: '' });
export const onPaySuccess = (state, { paymentRecord }) =>
  state.merge({ fetching: false, paymentRecord, error: '' });
export const onPaymentMethodsSuccess = (state, { paymentMethods }) =>
  state.merge({ fetching: false, paymentMethods });
export const onSubmitPaymentSuccess = (state, { paymentRecord }) =>
  state.merge({ fetching: false, paymentRecord, error: '' });
export const onSentPaymentLinkSuccess = (state) =>
  state.merge({ fetching: false, linkSent: true });
export const onClearPaymentLintSent = (state) =>
  state.merge({ linkSent: false });
export const onLogout = () => INITIAL_STATE;
/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [PaymentTypes.GET_FEES_REQUEST]: onRequest,
  [PaymentTypes.GET_FEES_SUCCESS]: onFeesSuccess,
  [PaymentTypes.GET_FEES_FAILURE]: onFailure,
  [PaymentTypes.GET_QUOTE_REQUEST]: onRequest,
  [PaymentTypes.GET_QUOTE_SUCCESS]: onQuoteSuccess,
  [PaymentTypes.GET_QUOTE_FAILURE]: onFailure,
  [PaymentTypes.GET_PAYMENT_METHODS_REQUEST]: onRequest,
  [PaymentTypes.GET_PAYMENT_METHODS_SUCCESS]: onPaymentMethodsSuccess,
  [PaymentTypes.GET_PAYMENT_METHODS_FAILURE]: onFailure,
  [PaymentTypes.GET_PAYMENT_INFO_REQUEST]: onRequest,
  [PaymentTypes.GET_PAYMENT_INFO_SUCCESS]: onQuoteSuccess,
  [PaymentTypes.GET_PAYMENT_INFO_FAILURE]: onFailure,
  [PaymentTypes.PAY_REQUEST]: onRequest,
  [PaymentTypes.PAY_SUCCESS]: onPaySuccess,
  [PaymentTypes.PAY_FAILURE]: onFailure,
  [PaymentTypes.SUBMIT_ZERO_PAYMENT]: onRequest,
  [PaymentTypes.SUBMIT_PAYMENT_REQUEST]: onRequest,
  [PaymentTypes.SUBMIT_PAYMENT_SUCCESS]: onSubmitPaymentSuccess,
  [PaymentTypes.SUBMIT_PAYMENT_FAILURE]: onFailure,
  [PaymentTypes.PERFORM_CASH_PAYMENT_FLOW]: onRequest,
  [PaymentTypes.PERFORM_MOCK_PAYMENT_FLOW]: onRequest,
  [PaymentTypes.SEND_PAYMENT_LINK]: onRequest,
  [PaymentTypes.SEND_PAYMENT_LINK_SUCCESS]: onSentPaymentLinkSuccess,
  [PaymentTypes.SEND_PAYMENT_LINK_FAILURE]: onFailure,
  [PaymentTypes.CLEAR_PAYMENT_LINK_SENT]: onClearPaymentLintSent,
  [PaymentTypes.MARK_FOR_LOCAL_PAYMENT]: onRequest,
  [PaymentTypes.MARK_FOR_LOCAL_PAYMENT_SUCCESS]: onSuccess,
  [PaymentTypes.MARK_FOR_LOCAL_PAYMENT_FAILURE]: onFailure,
  [ApplicationTypes.CLEAR_CURRENT_APPLICATION]: onClearCurrent,
  [LoginTypes.LOGOUT_SUCCESS]: onLogout,
});

/* ------------- Selectors ------------- */
export const getError = (state) => state.payment.error;
export const isFetching = (state) => state.payment.fetching;
export const getFees = (state) => state.payment.fees;
export const getMappedFees = (state) => state.payment.mappedFees;
export const getQuote = (state) => state.payment.quote;
export const getPaymentRecord = (state) => state.payment.paymentRecord;
export const getAllPaymentMethods = (state) => state.payment.paymentMethods;
export const isPaymentLinkSent = (state) => state.payment.linkSent;



// WEBPACK FOOTER //
// ./src/state/reducers/PaymentReducer.js